import { Injectable } from "@angular/core";
@Injectable()
export class PaginationModel{
    Page:Number;
    PageSize:Number; 
    OrderBy:String; 
    Order:String;
    Filter:String; 
    AlertType:String;
    FalseAlert:Number;
    StartDate:String;
    EndDate:String;
    Status:Number; 
    GroupId:String;
    GroupName:String;
    Role:String;
    FilterDate:String; 
    TimeZone:Number;
    AgentId:Number;
    AlertId:Number;
    ChatHistory:boolean;
    ZoneId:Number;
    OutOfZone: String;
    Late: String;
    MonthYear: String;
}